import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { LogicielCaisseAuthService } from 'app/services/logiciel-caisse/logiciel-caisse-auth.service';
import { ensureHttpsUrl, isSafeToAttachAuthToken } from './ssl-auth.util';

@Injectable()
export class LogicielCaisseInterceptor implements HttpInterceptor {
  private readonly lcBase: string;

  constructor(private readonly lcAuth: LogicielCaisseAuthService) {
    const raw =
      environment.api_logiciel_caisse ??
      (environment as { base_api_logiciel_caisse?: string }).base_api_logiciel_caisse ??
      '';
    this.lcBase = ensureHttpsUrl(String(raw).replace(/\/$/, ''));
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let req = request;
    const secureUrl = ensureHttpsUrl(req.url);
    if (secureUrl !== req.url) {
      console.warn('[LC Interceptor] upgrade HTTP → HTTPS', req.url, '→', secureUrl);
      req = req.clone({ url: secureUrl });
    }

    if (!this.lcBase || !this.matchesLcApi(req.url)) {
      return next.handle(req);
    }

    const token = this.lcAuth.getLogicielCaisseToken();
    if (!token) {
      return next.handle(req);
    }

    if (!isSafeToAttachAuthToken(req.url)) {
      console.error(
        '[LC Interceptor] JWT caisse non attaché : URL non sécurisée (SSL requis)',
        req.url
      );
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
    );
  }

  private matchesLcApi(url: string): boolean {
    if (url.startsWith(this.lcBase)) {
      return true;
    }
    if (this.lcBase.startsWith('/')) {
      try {
        const pathname = new URL(url, 'https://localhost').pathname;
        return pathname === this.lcBase || pathname.startsWith(`${this.lcBase}/`);
      } catch {
        return false;
      }
    }
    return false;
  }
}
